import React, {useMemo} from 'react';
import {Image, ImageBackground, Linking, View} from 'react-native';
import prizereminder from '../../../../Assets/Images/Svgs/prizereminder.svg';
import union from '../../../../Assets/Images/Svgs/union.svg';
import pawns from '../../../../Assets/Images/Svgs/pawns.svg';
import pawnpair from '../../../../Assets/Images/Svgs/pawnpair.svg';
import prizeapp from '../../../../Assets/Images/Svgs/prizeapp.svg';
import CCText from '@/Atoms/CCText';
import {FontSizes} from '@/Utils/Dimensions';
import CCColors from '@/Utils/CCColors';
import Box from '@/Atoms/Box';
import {RFPercentage} from 'react-native-responsive-fontsize';
import MaterialCommunityIcon from 'react-native-vector-icons/MaterialCommunityIcons';
import {StyleSheet} from 'react-native';
import CCButton from '@/Atoms/CCButton';
import {useMediaQuery} from '@/Hooks/useMediaQuery/useMediaQuery';
import {useNavigation} from '@react-navigation/native';
import {usePrizeTournamentsApi} from '@/Hooks/GetTournaments/useGetPrizeTournaments';
import {TARGET_ID} from '@/Utils/Constants';
import {LinearGradient} from 'expo-linear-gradient';
import {ScreenName} from '@/navigators/StackConstants';
import dayjs from 'dayjs';

const TournamentReminder = ({tournament, setShowReminder}) => {
  const {isMobileOrTab} = useMediaQuery();
  const navigation = useNavigation();
  const isConfigBanner = tournament?.[0]?.config_banner === true;
  const hasButtonText = !!tournament?.[0]?.button_text;
  const buttonText = isConfigBanner ? tournament?.[0]?.button_text : 'Join Now';
  const shouldShowButton = (isConfigBanner && hasButtonText) || !isConfigBanner;
  function formatDate(inputDateTime: string | undefined): string {
    if (!inputDateTime) {
      return '';
    }
    // const date = dayjs(inputDateTime);

    // Convert the input UTC datetime to the user's local time zone
    const date = dayjs.utc(inputDateTime).tz('Asia/Kolkata');
    const today = dayjs().tz('Asia/Kolkata');
    const isSameDay = date.isSame(today, 'day');
    const day = date.date();
    let dayOrdinal = day.toString();
    if (day % 10 === 1 && day !== 11) {
      dayOrdinal += 'st';
    } else if (day % 10 === 2 && day !== 12) {
      dayOrdinal += 'nd';
    } else if (day % 10 === 3 && day !== 13) {
      dayOrdinal += 'rd';
    } else {
      dayOrdinal += 'th';
    }

    // Get the month name
    const monthName = date.format('MMM');

    // Get the last two digits of the year
    const year = date.format('YY');

    // Get the time in 12-hour format with AM/PM
    const timeStr = date.format('hh:mm A');
    if (isSameDay) {
      return `Today @ ${timeStr}`;
    }
    // Compose the final date-time string
    const formattedDate = `${dayOrdinal} ${monthName} @ ${timeStr}`;

    return formattedDate;
  }
  const handlePress = () => {
    const action = tournament?.[0]?.button_action;

    if (!action) {
      navigation.navigate(ScreenName.PlayChess, {
        tournamentId: tournament?.[0]?.id,
        tournamentName: tournament?.[0]?.name,
        isJoined: true,
      });
      return;
    }

    const {type, value, open_in_new_tab} = action;

    if (type === 'LINK') {
      if (open_in_new_tab) {
        window.open(value);
      } else {
        window.location.href = value;
      }
      return;
    }

    if (type === 'PATH') {
      const url = window.location.origin + value;

      if (open_in_new_tab) {
        window.open(url, '_blank');
      } else {
        setShowReminder(false); // adjust if navigation needed
      }
      return;
    }

    if (type === 'CLOSE') {
      setShowReminder(false);
      return;
    }
  };

  // console.log(tournament, ' tournament data');
  return isMobileOrTab ? (
    <Box style={styles.mobilecontainer}>
      <LinearGradient
        colors={[CCColors.BorderLight, CCColors.Primary.Default]} // Outer gradient border: soft yellow tones
        start={{x: 0, y: 0.5}}
        end={{x: 1, y: 0.5}}
        style={styles.border}>
        <View style={{position: 'relative'}}>
          <LinearGradient
            colors={[CCColors.FadedYellow, CCColors.White]} // Bright yellow to a pale yellow/white
            start={{x: 0, y: 0.5}} // Left center
            end={{x: 1, y: 0.5}} // Right center
            style={styles.bordergradient}>
            <Box flexDirection="column" style={styles.mobileprize}>
              <CCText fontSize={RFPercentage(2.4)} fontWeight={600}>
                {tournament?.[0]?.name ?? 'Daily Prize Tournament'}
              </CCText>
              {tournament?.[0]?.center_text ? (
                <CCText
                  style={{width: '60%'}}
                  fontSize={RFPercentage(1.8)}
                  fontWeight={500}>
                  {tournament?.[0]?.center_text ?? 'Bullet'}
                </CCText>
              ) : (
                <>
                  <Box flexDirection="row" gap={10} style={styles.upperText}>
                    <Box flexDirection="row" alignItems="center" gap={5}>
                      <Image source={pawns} style={styles.pawns} />
                      <CCText fontSize={RFPercentage(1.8)} fontWeight={500}>
                        {tournament?.[0]?.time_format ?? 'Bullet'}
                      </CCText>
                    </Box>
                    {/* <Box flexDirection="row" alignItems="center" gap={5}>
                  <MaterialCommunityIcon
                    name="ticket-confirmation-outline"
                    size={19}
                    color={CCColors.Primary.Brown}
                  />

                  <CCText fontSize={RFPercentage(1.8)} fontWeight={500}>
                    {tournament?.[0]?.entry_fee === 0
                      ? 'Free'
                      : tournament?.[0]?.entry_fee ?? 'Free'}{' '}
                    Free Entry
                  </CCText>
                </Box> */}
                  </Box>
                  <Box flexDirection="row" gap={10} style={styles.text}>
                    <Box flexDirection="row" alignItems="center" gap={5}>
                      <MaterialCommunityIcon
                        name="calendar-outline"
                        size={19}
                        color={CCColors.Primary.Brown}
                      />

                      <CCText fontSize={RFPercentage(1.8)} fontWeight={500}>
                        Starts{' '}
                        {formatDate(tournament?.[0]?.start_date) || '8pm Today'}
                      </CCText>
                    </Box>
                  </Box>
                </>
              )}
            </Box>
          </LinearGradient>
          {/* SVG in the top-right corner */}
          <View style={styles.image}>
            <Image
              source={tournament?.[0]?.display_pic ?? prizeapp}
              style={{
                height: 60,
                width: 100,
                borderBottomLeftRadius: tournament?.[0]?.display_pic ? 30 : 0,
              }}
            />
          </View>
          <View>
            <CCButton
              style={styles.mobilejoin}
              contentContainerStyle={{
                paddingHorizontal: 15,
              }}
              onPress={handlePress}>
              <CCText fontSize={RFPercentage(1.8)} fontWeight={'bold'}>
                {tournament?.[0]?.button_text ?? 'Join Now'}
              </CCText>
            </CCButton>
          </View>
        </View>
      </LinearGradient>
    </Box>
  ) : (
    <ImageBackground
      source={{uri: tournament?.[0]?.banner_background}}
      style={[
        styles.container,
        {
          paddingVertical:
            tournament?.[0]?.display_pic || !isConfigBanner ? 3 : 15,
        },
      ]}
      imageStyle={styles.containerImage}
      resizeMode="cover">
      {isConfigBanner ? (
        tournament?.[0]?.display_pic ? (
          <Image source={tournament?.[0]?.display_pic} style={styles.prize} />
        ) : null
      ) : (
        <Image
          source={tournament?.[0]?.display_pic ?? prizereminder}
          style={styles.prize}
        />
      )}
      {isConfigBanner ? (
        tournament?.[0]?.name ? (
          <CCText
            fontSize={FontSizes[20]}
            color={CCColors.White}
            style={{
              marginLeft: 10,
            }}
            fontWeight={600}>
            {tournament?.[0]?.name}
          </CCText>
        ) : null
      ) : (
        <CCText
          fontSize={FontSizes[20]}
          color={CCColors.White}
          style={{
            marginLeft: 10,
          }}
          fontWeight={600}>
          {tournament?.[0]?.name ?? 'Daily Prize Tournament'}
        </CCText>
      )}
      <Box
        flexDirection="row"
        gap={15}
        style={[
          styles.subcontainer,
          {
            marginLeft:
              tournament?.[0]?.center_text?.length > 49 ? '6%' : '11%',
          },
        ]}>
        {isConfigBanner ? (
          tournament?.[0]?.center_text ? (
            <>
              <CCText
                textAlign="center"
                color={CCColors.White}
                fontSize={
                  tournament?.[0]?.center_text?.length > 49
                    ? FontSizes[11]
                    : FontSizes[16]
                }
                fontWeight={
                  tournament?.[0]?.center_text?.length > 49 ? 600 : 500
                }>
                {tournament?.[0]?.center_text}
              </CCText>
            </>
          ) : null
        ) : (
          <>
            <Box flexDirection="row" alignItems="center" gap={5}>
              <Image source={pawnpair} style={styles.pawns} />
              <CCText
                color={CCColors.White}
                fontSize={FontSizes[16]}
                fontWeight={500}>
                {tournament?.[0]?.time_format ?? 'Bullet'}
              </CCText>
            </Box>
            {/* <Box flexDirection="row" alignItems="center" gap={5}>
          <MaterialCommunityIcon
            name="ticket-confirmation-outline"
            size={18}
            color={CCColors.White}
          />

          <CCText
            color={CCColors.White}
            fontSize={FontSizes[16]}
            fontWeight={500}>
            {tournament?.[0]?.entry_fee === 0
              ? 'Free'
              : tournament?.[0]?.entry_fee ?? 'Free'}{' '}
            Free Entry
          </CCText>
        </Box> */}
            <Box flexDirection="row" alignItems="center" gap={5}>
              <MaterialCommunityIcon
                name="calendar-outline"
                size={18}
                color={CCColors.White}
              />

              <CCText
                color={CCColors.White}
                fontSize={FontSizes[16]}
                fontWeight={500}>
                Starts {formatDate(tournament?.[0]?.start_date) ?? '8pm Today'}
              </CCText>
            </Box>
          </>
        )}
      </Box>

      <Box style={styles.join}>
        {shouldShowButton && (
          <CCButton
            onPress={handlePress}
            contentContainerStyle={{
              paddingHorizontal: 30,
            }}>
            <CCText
              fontSize={FontSizes[14]}
              color={CCColors.Primary.Brown}
              fontWeight="bold">
              {buttonText}
            </CCText>
          </CCButton>
        )}
      </Box>

      <Image source={union} style={styles.union} />
    </ImageBackground>
  );
};
const styles = StyleSheet.create({
  container: {
    width: '99%',
    paddingVertical: 3,
    backgroundColor: CCColors.TextColor.Dark,
    position: 'relative',
    borderRadius: 12,
    alignItems: 'center',
    justifyContent: 'flex-start',
    flexDirection: 'row',
    marginLeft: 8,
    overflow: 'hidden',
  },
  containerImage: {
    borderRadius: 12,
  },
  prize: {
    margin: 2,
    borderRadius: 10,
    width: 60,
    height: 60,
    marginLeft: 5,
  },
  subcontainer: {marginLeft: '11%', maxWidth: '40%'},
  join: {
    position: 'absolute',
    right: 30,
  },
  union: {
    margin: 2,
    borderRadius: 12,
    width: 144,
    height: 80,
    position: 'absolute',
    top: 0,
    right: 0,
    zIndex: -1,
  },
  pawns: {
    width: 18,
    height: 18,
  },
  mobilecontainer: {
    paddingHorizontal: 16,
    paddingTop: 20,
    width: '100%',
  },
  border: {
    borderRadius: 12,
    padding: 1.8, // This controls the thickness of the border
  },
  bordergradient: {
    width: '100%',
    borderRadius: 10,
  },
  box: {height: '100%', width: '100%'},
  mobileprize: {
    alignItems: 'flex-start',
    justifyContent: 'center',
    padding: 16,
    zIndex: 100,
  },
  text: {
    marginTop: '1%',
  },
  upperText: {
    marginTop: '4%',
  },
  rightBox: {
    alignItems: 'flex-end',
    justifyContent: 'flex-start',
    height: '90%',
    width: '30%',
  },
  mobilejoin: {
    position: 'absolute',
    bottom: 10,
    right: 22,
  },
  image: {
    position: 'absolute',
    top: 0,
    right: 0,
    borderTopRightRadius: 10,
    overflow: 'hidden',
  },
});
export default TournamentReminder;
